export const MONACO = 'MCO'
export const ST_MARTIN = 'MAF'
export const ST_PIERRE_AND_MIQUELON = 'SPM'
export const ST_BARTHELEMY = 'BLM'
export const FRANCE = 'FRA'
export const MAYOTTE = 'MYT'
export const GUYANNE_FRANCAISE = 'GUF'
export const GUADELOUPE = 'GLP'
export const MARTINIQUE = 'MTQ'
export const REUNION = 'REU'
export const EXCLUDED_FRENCH_COLONIES = [
  MONACO,
  ST_MARTIN,
  ST_BARTHELEMY,
  ST_PIERRE_AND_MIQUELON,
]

export const FRENCH_COLONIES = [
  FRANCE,
  MAYOTTE,
  GUYANNE_FRANCAISE,
  GUADELOUPE,
  MARTINIQUE,
  REUNION,
]
